import { default as Statuses } from '@cinch/oxd-utils/request-status/src'
import { RecommendationsService } from '@cinch/oxd-utils/requests/src'
import { useEffect, useState } from 'react'

const LifestyleRecommendations = (requestData?: RecommendationsService.RecommendationRequest) => {
  const [recommendations, setRecommendations] = useState<Cinch.RecommendationsItem[]>([])
  const [status, setStatus] = useState<string>(Statuses.INITIAL)

  const getRecommendations = async (lifestyleData: Partial<RecommendationsService.RecommendationRequest>) => {
    const result = await RecommendationsService.getRecommendations(lifestyleData)

    return result.data
  }

  useEffect(() => {
    if (requestData) {
      setStatus(Statuses.PENDING)
      getRecommendations(requestData).then((response) => {
        setRecommendations(response.recommendations)
        setStatus(Statuses.SUCCESS)
      })
    }
  }, [requestData])

  return {
    recommendations,
    status,
  }
}

export default LifestyleRecommendations
